import { apiService } from "../apiService";
import urlConfig from "../../../config/domain";

export const AGetMarginFiles = (callback: CallableFunction, fileType: string) => {
		apiService(
			{
				url: urlConfig.marginFiles.marginFiles + "?filetype=" + fileType,
				method: "GET"
			},
			callback
		);
};
